import { Controller } from "stimulus";
import { Turbo } from "@hotwired/turbo-rails";

export default class extends Controller {
  static targets = ["scheduleButton"];

  appendQueryParams(params) {
    const pageParams = new URLSearchParams(window.location.search);
    const guardianPupilId = pageParams.get("guardian_pupil")?.trim();
    if (guardianPupilId) params.append("guardian_pupil", guardianPupilId);
    const locale = pageParams.get("locale")?.trim();
    if (locale) params.append("locale", locale);
  }

  async showScheduleClassroomMakeUpQuickLook(event) {
    event.preventDefault();

    const attendanceId = this.data.get("attendanceId");
    if (!attendanceId) return;

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;

    const params = new URLSearchParams();
    params.append("attendance_id", attendanceId);
    this.appendQueryParams(params);

    const response = await fetch(`/us/dashboard/student/classroom/quick-look/schedule?${params.toString()}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "X-CSRF-Token": csrfToken,
        "Accept": "text/vnd.turbo-stream.html"
      }
    });

    if (!response.ok) return;

    const quickLookElement = document.querySelector("#driving-school-student-dashboard-quick-look");
    if (!quickLookElement) return;

    quickLookElement.classList.remove("u-hidden");
    const responseBody = await response.text();

    if (Turbo && typeof Turbo.renderStreamMessage === "function") {
      Turbo.renderStreamMessage(responseBody);
    }
  }

  onMakeUpSessionSelected(event) {
    if (!this.hasScheduleButtonTarget) return;

    const selectedId = event?.detail?.id?.toString()?.trim() || "";
    const hasValue = selectedId.length > 0;
    this.scheduleButtonTarget.disabled = !hasValue;
    this.scheduleButtonTarget.setAttribute("aria-disabled", hasValue ? "false" : "true");
  }

  async scheduleClassroomMakeUp(event) {
    event.preventDefault();

    const attendanceId = this.data.get("attendanceId");
    const selectedSessionId = document.querySelector("#student_make_up_classroom_session_id")?.value;
    if (!attendanceId || !selectedSessionId) return;

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
    const body = new URLSearchParams();
    body.append("attendance_id", attendanceId);
    body.append("student_make_up_classroom_session_id", selectedSessionId);
    this.appendQueryParams(body);

    const response = await fetch("/us/dashboard/student/classroom/quick-look/schedule", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "X-CSRF-Token": csrfToken,
        "Accept": "text/vnd.turbo-stream.html"
      },
      body: body.toString()
    });

    if (!response.ok) return;

    const responseBody = await response.text();
    if (Turbo && typeof Turbo.renderStreamMessage === "function") {
      Turbo.renderStreamMessage(responseBody);
    }
  }

  closeQuickLook(event) {
    if (event) event.preventDefault();
    const quickLookElement = document.querySelector("#driving-school-student-dashboard-quick-look");
    if (!quickLookElement) return;
    quickLookElement.classList.add("u-hidden");
  }
}
